import { Actor } from "../actors/Actor";
import { Item } from "../items/Item";

export const useItem = (actor: Actor, { item }: { item: Item }) => {
  if (item) {
    item.useItem(actor);
    return { valid: true };
  }
  return { valid: false };
};
